import { action, makeObservable, observable } from 'mobx'

import Localization from '../../localization/LocalizationManager'
import AuthenticationStore from '../../stores/domain/Authentication.store'
import CommonStore from '../../stores/ui/Common.store'
import { secondsToFullHours } from '../../stores/ui/ProjectDate.store'
import { getTokenPayload } from '../../utils/JwtHelper'
import { toast } from '../../utils/toast'

export default class ExpiredInviteKeyInfo {
  @observable public wasInviteResent: boolean = false
  @observable public isLoading: boolean = false

  public constructor(
    private readonly expiredInviteKey: string,
    private readonly auth: AuthenticationStore,
    private readonly common: CommonStore,
  ) {
    makeObservable(this)
  }

  public get durationOfInviteKeyInHours(): number {
    try {
      const { exp, iat } = getTokenPayload(this.expiredInviteKey)
      // eslint-disable-next-line no-var
      var durationInHours = secondsToFullHours(exp - iat)
    } catch {
      /* empty */
    }

    return durationInHours || 0
  }

  @action.bound
  public async handleResendInvitation() {
    this.isLoading = true

    try {
      await this.auth.resendInviteKey(this.expiredInviteKey)
    } catch {
      toast.error(Localization.translator.somethingWentWrongPleaseTryAgain)
      return
    } finally {
      this.isLoading = false
    }

    this.wasInviteResent = true
  }

  public handleClose = () => {
    this.common.displayLoginView()
  }
}
